import request from '@/utils/request';

export const postLoginOrRegist = data => {
	// avatarAddress
	// createTime
	// deviceCode
	// deviceOs
	// enrollIp
	// id
	// openid
	// phone
	// status
	// studentName
	// unionid
	// updateTime
	return request({
		url: '/user/student/na/saveStudentInfo',
		method: 'post',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		data,
	});
};

export const getUserInfo = data => {
	return request({
		url: '/user/student/info',
		method: 'get',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		params: data,
	});
};

export const getUpdatePhone = data => {
	return request({
		url: '/user/student/changePhone',
		method: 'get',
		type: 'json', // formDate类型数据值为 'form'
		// type: 'form',
		params: data,
	});
};
